export const tabsTypes = {
  PROFILE: 'PROFILE',
  DOCUMENTATION: 'DOCUMENTATION',
  LOYALTY: 'LOYALTY',
};
export const advantageNetworkTypes = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING',
};
export const kycStatusType = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING',
  SEND: 'SEND',
  REVALIDATION: 'REVALIDATION',
  SEND_WITH_OBSERVATIONS: 'SEND_WITH_OBSERVATIONS',
};


export const AREA_OPTIONS = ['AREA', 'EXTRA_PRODUCT'];
export const GROUP_OPTIONS = [
  'MENU_MAIN',
  'MENU_SPECIAL',
  'OPEN_BAR_HOURS',
  'EXTRA_PRODUCT',
  'UNIQUE_EXTRA_PRODUCT',
  'PER_HOUR_ALL_PAX',
];
